import { render, staticRenderFns } from "./AdminInvoiceTableRow.vue?vue&type=template&id=c25dff2e&"
import script from "./AdminInvoiceTableRow.vue?vue&type=script&lang=ts&"
export * from "./AdminInvoiceTableRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QTd});
